var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsmid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.589,
    height: 24.022,
    viewBox: "0 0 20.589 24.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4397",
    "data-name": "Group 4397",
    transform: "translate(-1642.677 -837.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4396",
    "data-name": "Group 4396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8962",
    "data-name": "Path 8962",
    d: "M1652.95,837.865a.854.854,0,0,0-.514.188l-1.681,1.346a17.851,17.851,0,0,1-5.512,3l-1.979.658a.858.858,0,0,0-.586.815v3.687a15.2,15.2,0,0,0,10,14.277.835.835,0,0,0,.291.052h0a.838.838,0,0,0,.292-.052,15.2,15.2,0,0,0,10-14.277v-3.687a.859.859,0,0,0-.586-.815l-1.979-.658a17.856,17.856,0,0,1-5.513-3l-1.68-1.346a.861.861,0,0,0-.558-.188Zm.022,1.957,1.146.917a19.572,19.572,0,0,0,6.042,3.286l1.39.464v3.068a13.561,13.561,0,0,1-2.688,8.036,13.3,13.3,0,0,1-5.891,4.468,13.841,13.841,0,0,1-5.754-4.289,13.13,13.13,0,0,1-2.825-8.215v-3.068l1.39-.464a19.572,19.572,0,0,0,6.042-3.286Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8963",
    "data-name": "Path 8963",
    d: "M1652.3,846.558a1.719,1.719,0,0,0-1.719,1.719h0a1.718,1.718,0,0,0,.861,1.488v1.944a.858.858,0,0,0,1.716.025v-1.97a1.718,1.718,0,0,0-.856-3.207Z",
    transform: "translate(0.674 0.741)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsmid);
export default __webpack_public_path__ + "static/media/settingsmid.9d40352d.svg";
export { ForwardRef as ReactComponent };